var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyNurse4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H64C72.8366 0 80 7.16344 80 16V64C80 72.8366 72.8366 80 64 80H16C7.16344 80 0 72.8366 0 64V16Z",
    fill: "#EAE3FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59 34V41H52C49.243 41 47 43.243 47 46C47 48.757 49.243 51 52 51H59V58C59 59.6545 57.6545 61 56 61H24C22.3455 61 21 59.6545 21 58V34C21 32.3455 22.3455 31 24 31H56C57.6545 31 59 32.3455 59 34ZM52 43H59V49H52C50.3455 49 49 47.6545 49 46C49 44.3455 50.3455 43 52 43ZM54 45H52C51.448 45 51 45.448 51 46C51 46.552 51.448 47 52 47H54C54.552 47 55 46.552 55 46C55 45.448 54.552 45 54 45ZM42.086 29L47.975 23.111L46.889 22.025L39.9135 29H42.086ZM45.475 20.6105L45.182 20.3175C43.427 18.5635 40.5725 18.5635 38.8175 20.3175L30.136 29H37.0855L45.475 20.6105ZM53.864 29L49.3895 24.525L44.914 29H53.864Z",
    fill: "#9473F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyNurse4);
export default __webpack_public_path__ + "static/media/whyNurse4.a346536be7714fd8924fc10acd9ca7f1.svg";
export { ForwardRef as ReactComponent };